import {
  React, Component,
  connect, reducerAndActionsFor, createGenericStore,
  className, _
} from './generic';

import createStore from './redux/helpers/create-store';
import {logIn, logOut, signUp, updateMyAccount} from './redux/reducers/session/session-reducer';
import {resourceActions} from './redux/reducers/resources/resources-reducer';
import {resourceFor, mixinNodeResource} from './misc/mixins/node-resource/node-resource-mixin';
import appsData from './apps-data';

import Page from './components/page/page';
import Logo from './components/logo/logo';
import Header from './components/header/header';
import AppWrapper from './components/app-wrapper/app-wrapper';

import {api} from '@symbolic/lib';

var fileUrl = (uri) => `https://symbolic-public.s3.amazonaws.com/${uri}`;

require('henrybuilt-js-library');

var lib = window.lib;

export {
  React, Component,
  Page, Logo, AppWrapper, Header,

  connect, reducerAndActionsFor, createStore, createGenericStore,
  logIn, logOut, signUp, updateMyAccount,
  resourceActions,

  appsData, className, lib, _, api, fileUrl,

  resourceFor, mixinNodeResource
};
